import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {map} from "rxjs/operators";

interface Sentence {
  id: string;
  sentence: string;
}

@Injectable({
  providedIn: 'root'
})


export class SentenceServiceService {
  private jsonURL = 'assets/arctic_sentences.json';
  sentences: Sentence[] = [];
  currentSentence: BehaviorSubject<Sentence>;
  currentSentenceObservable: Observable<Sentence>;

  constructor(private http: HttpClient) {
    this.currentSentence = new BehaviorSubject<Sentence>({id: '', sentence: ''});
    this.currentSentenceObservable = this.currentSentence.asObservable();
    this.getJSON().subscribe(data => {
      this.sentences = data;
    });
  }

  public getJSON(): Observable<Sentence[]> {
    return this.http.get(this.jsonURL) as Observable<Sentence[]>;
  }

  public getRandomSentence(): Observable<Sentence> {
    const index = Math.floor(Math.random() * Math.floor(1132));
    return this.getJSON().pipe(map(data => {
      return this.sentences[index] as Sentence;
    }));
    // return of(this.sentences[index]);
    // return new Observable<Sentence>(observer => {
    //   const index = Math.floor(Math.random() * Math.floor(1132));
    //   observer.next(this.sentences[index]);
    // });
  }
}
